export default __webpack_public_path__ + "static/media/tape.03a04064.png";